import { getSupport } from '../../shared/get-support.js';

export default {
  name: 'support',
  static: {
    getSupport,
  },
};
